import React, { useState, useEffect, useContext } from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import NavbarMenu from "app/components/Navbars/NavBarMenu.js";
import NavbarSearch from "app/components/Navbars/NavBarSearch.js";
import NavbarNotification from "app/components/Navbars/NavBarNotification.js";
import NavbarProfile from "app/components/Navbars/NavBarProfile.js";
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import whiteLogo from "../../layout/leoWebWhite.png";
import PropTypes from "prop-types";

export default function Header(props) {

    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar style={{background: '#ef2927'}} position="static">
                <Toolbar>
                    <img src={whiteLogo} style={{ height: '8%', width: '8%' }}  alt="newLogo" />
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' }
                            }}
                        >
                            <Link to={'/LeoSeaPortal/dashboard'}>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    style={{ background: '#ef2927' }}
                                >
                                    Dashboard
                                </Button>
                            </Link>
                            <NavbarMenu menuName={'Quotes'} subMenus={[{ 'name': 'Create Quote', 'url': '/LeoSeaPortal/createquote' }, { 'name': 'Search Quotes', 'url': '/LeoSeaPortal/searchquote' }]}> </NavbarMenu>
                            <NavbarMenu menuName={'Bookings'} subMenus={[{ 'name': 'Create Booking', 'url': '/LeoSeaPortal/createbooking' }, { 'name': 'Search Bookings', 'url': '/LeoSeaPortal/searchbooking' }]}> </NavbarMenu>
                            <NavbarMenu menuName={'Notifications'} subMenus={[{ 'name': 'Search Notifications', 'url': '/LeoSeaPortal/notifications' }]}> </NavbarMenu>
                        </Menu>
                        
                    </Box>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        <Link to={'/LeoSeaPortal/dashboard'}>
                            <Button
                                variant="contained"
                                disableElevation
                                style={{ background: '#ef2927' }}
                            >
                                Dashboard
                            </Button>
                        </Link>
                        <NavbarMenu menuName={'Quotes'} subMenus={[{ 'name': 'Create Quote', 'url': '/LeoSeaPortal/createquote' }, { 'name': 'Search Quotes', 'url': '/LeoSeaPortal/searchquote' }]}> </NavbarMenu>
                        <NavbarMenu menuName={'Bookings'} subMenus={[{ 'name': 'Create Booking', 'url': '/LeoSeaPortal/createbooking' }, { 'name': 'Search Bookings', 'url': '/LeoSeaPortal/searchbooking' }]}> </NavbarMenu>
                        <NavbarMenu menuName={'Notifications'} subMenus={[{ 'name': 'Search Notifications', 'url': '/LeoSeaPortal/notifications' }, { 'name': 'Notification Settings', 'url': '/LeoSeaPortal/notificationsettings' }]}> </NavbarMenu>
                    </Box>

                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <NavbarSearch />
                    </Box>
                    
                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <NavbarNotification />
                        <NavbarProfile />
                    </Box>
                    <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                        <NavbarSearch />
                        <NavbarNotification />
                        <NavbarProfile />
                    </Box>
                </Toolbar>
            </AppBar>
        </Box>
    );
}

Header.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
};
